import React from 'react'
import { l } from '@manychat/manyui'

const FBPageConnectionWasSuccessfullyReloadedNotification = () => {
  return <span>{l.translate('The page connection was successfully reloaded')}</span>
}

export default FBPageConnectionWasSuccessfullyReloadedNotification
